import React from "react";
import PropTypes from "prop-types";

const TranscriptUsedInPortal = ({
  transcript,
  reason,
  refGenome,
  varsomeHost,
}) => {
  if (__IS_COMPONENTS_PORTAL__ && transcript) {
    return (
      <span>
        Using transcript{" "}
        <a
          href={`${varsomeHost}/transcript/${refGenome}/${transcript}`}
          target="_blank"
        >
          {transcript}
        </a>
        {reason ? `, ${reason}.` : "."}
      </span>
    );
  }
  return null;
};

TranscriptUsedInPortal.propTypes = {
  transcript: PropTypes.string,
  reason: PropTypes.string,
  varsomeHost: PropTypes.string.isRequired,
  refGenome: PropTypes.string.isRequired,
};

TranscriptUsedInPortal.defaultProps = {
  transcript: null,
  reason: null,
};

export default React.memo(TranscriptUsedInPortal);
